<template>
<section id="portfolio" class="py-5 " style="display:inline-block">
<div class="container">
  <div class="shadow-lg p-3 mb-5 bg-body-tertiary rounded">
  <h2>Projets Personnels</h2></div>
  <div class="row row-cols-1 row-cols-md-3 g-4 card-group my-4">
  <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/maquette1.png" class="card-img-top rounded float-start" alt="maquette html" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Reproduction de la maquette avec du html et css</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
  </div>
  <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/blog.png" class="card-img-top rounded float-start" alt="Blog en django" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Création d'un blog avec Django</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
  </div>
  <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/bteau.png" class="card-img-top rounded float-start" alt="site de vente de cd " width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Disquaire: projet d'apprentissage du Framework Django</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
</div>
<div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/senbio.png" class="card-img-top rounded float-start" alt="site de vente des produits locaux" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Site de vente des produits locaux avec Php</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
  </div>
  <div class="">
  <div class="card p-2 h-100">
    <img src="../assets/2c.png" class="card-img-top rounded float-start" alt="site couturier" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Site couturier avec Symfony</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
</div>
 <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/logo.jpg" class="card-img-top rounded float-start" alt="site d'informations" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Site d'informations pour les étudiants avec Php</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
  </div>
  <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/jeupendu.png" class="card-img-top rounded float-start" alt="jeu pendu" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Jeu pendu en console avec python</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
  </div>
  <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/portfolio.png" class="card-img-top rounded float-start" alt="Portfolio" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Mon port folio avec VueJs</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
 </div>
 <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/helplogo.png" class="card-img-top rounded float-start" alt="Portfolio" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Site d'informations avec vue js (en cours)</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
 </div>
  

</div>

<div class="shadow-lg p-3 mb-5 bg-body-tertiary rounded">
  <h2>Projets Scolaires</h2> <p>Travail en équipe </p></div>
  <div class="row row-cols-1 row-cols-md-3 g-4 card-group my-4">
  <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/smesp.png" class="card-img-top rounded float-start" alt="maquette html" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Site de maintenance pour ESP avec PHP </h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
  </div>
  <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/geolo.png" class="card-img-top rounded float-start" alt="Blog en django" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Application de géolocalition avec gestion de projets</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
  </div>
  <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/printa.png" class="card-img-top rounded float-start" alt="site de vente de cd " width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Editeur de texte en ligne avec Javascript</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
</div>
<div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/objet.png" class="card-img-top rounded float-start" alt="site de vente des produits locaux" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Reconnaissance d'objets avec Matlab</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
  </div>
  <div class="">
  <div class="card p-2 h-100">
    <img src="../assets/appsenbio.png" class="card-img-top rounded float-start" alt="site couturier" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Application mobile de Sen Bio avec React native</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
</div>
 <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/sudoku.png" class="card-img-top rounded float-start" alt="site d'informations" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Jeu sudoku en console avec C</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
  </div>
  <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/king.png" class="card-img-top rounded float-start" alt="jeu pendu" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Jeu kingdomino en graphique avec IA et python </h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
  </div>
  <div class="col">
  <div class="card p-2 h-100">
    <img src="../assets/toeic.png" class="card-img-top rounded float-start" alt="jeu pendu" width="474" height="237">
    <div class="card-body">
      <h5 class="card-title">Site d'entrainement pour les tests toeic avec React js</h5>
    </div>
    <div class="card-footer">
      <small class="text-muted"></small>
    </div>
  </div>
  </div>
  
  
  

</div>

</div>
</section>
</template>

<script>
export default {
    name:'WorkView'
}
</script>

<style>

</style>